<div
  class="history-log-modal"
>
  <div class="modal-header text-center">
    <div class="modal-title w-100">
      <h5 class="text-white history-log-modal__title">{{ entityType | titlecase }} History Logs</h5>
      <h4 class="text-white history-log-modal__title">{{ entityName || entityKey }}</h4>
    </div>

    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <!-- Shipments Table -->
    <app-forecast-rxdata-table
        *ngIf="!loading"
        itemName="HistoryLogs"
        [scrollable]="'none'"
        [entityType]="entityType"
        [entityKey]="entityKey"
        [isViewOnly]="true"
        [modelType]="historyLogRef"
        [resourceService]="historyLogsService"
        [additionalReadOnlyCols]="additionalReadOnlyCols"
        [initGridState]="gridState"
        [columns]="metaDataFields"
        [userMetaDataFields]="userMetaDataFields"
        [addIsVisible]="false"
        [deleteIsVisible]="false"
        [bulkMngtIsVisible]="false"
        [isExtraExportVisible]="false"
        [isFullScreen]="false"
        (columnChange)="onColumnChange($event)"
        (stateChange)="onStateChange($event)"
        (reorderChange)="onColumnReorder($event)"
        (gridViewChange)="onGridViewChange($event)"
        (columnResize)="onColumnResize($event)"
    ></app-forecast-rxdata-table>
  </div>
</div>